
import { Card, CardContent } from "@/components/ui/card";

const PartnershipImpact = () => {
  return (
    <section className="w-full bg-white/50 py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-teedee-blue mb-6">Partnership Impact</h2>
          <p className="text-xl lg:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            See how our collaborations create meaningful change in the community.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <img 
              src="https://images.unsplash.com/photo-1509062522246-3755977927d7?w=600&h=400&fit=crop" 
              alt="Children learning with Bobo & Teedee® educational materials"
              className="w-full h-96 object-cover rounded-3xl shadow-2xl"
            />
          </div>
          
          <div className="space-y-8">
            <Card className="bg-white/80 border-teedee-blue/20 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-teedee-blue mb-4">Educational Reach</h3>
                <p className="text-gray-600 text-lg leading-relaxed">
                  Through our partnerships, Bobo & Teedee® content reaches over 15,000 children across the Cayman Islands each year, both in schools and through community programs.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white/80 border-bobo-green/20 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-bobo-green mb-4">Cultural Programs</h3>
                <p className="text-gray-600 text-lg leading-relaxed">
                  Our collaborations have led to the creation of cultural education programs that help children connect with their Cayman Islands heritage while learning universal values.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white/80 border-brand-purple/20 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="p-8">
                <h3 className="text-2xl font-bold text-brand-purple mb-4">Community Events</h3>
                <p className="text-gray-600 text-lg leading-relaxed">
                  Together with our partners, we organize community events, workshops, and educational activities that bring families together for learning and fun.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipImpact;
